<template>
  <v-container fluid>
    <BreadHeader :title="`Delete ${modelName} Forever`"></BreadHeader>
    <AError :api="api" />
    <v-card>
      <v-card-text>
        <v-alert type="error">
          This action is irreversible. The data will be lost forever.
        </v-alert>
        <span
          >Are you sure you want to delete
          <b>{{ `${modelName}` }}</b> permanently?</span
        >
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn text @click="$router.go(-1)"> Cancel </v-btn>
        <v-btn :isLoading="api.isLoading" color="error" @click="api.fetch()">
          Delete Forever
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
import Api from "@/objects/api";
import BreadcrumbTabulator from "@/objects/breadcrumbTabulator";
import Model from "@/objects/model";
import Service from "@/objects/service";
import { mapState } from "vuex";

export default {
  computed: mapState({
    services: (state) => state.service.data.services,
  }),
  data: () => ({
    api: new Api(),
    breadcrumbTabulator: new BreadcrumbTabulator(),
    model: new Model(),
    modelId: null,
    modelName: null,
    service: new Service(),
    apiDeleteUrl: "",
  }),
  created() {
    this.model.getByKey(this.$route.params.modelKey);
    this.modelId = this.$route.params.modelId;
    this.modelName = `${this.model.name.singular} ${this.modelId}`;
    if (this.model.serviceKey) this.service.set("key", this.model.serviceKey);
    this.breadcrumbTabulator.addForOperationDeleteHard({
      services: this.services,
      model: this.model,
      modelId: this.modelId,
    });

    if (this.model.apiUrls.apiHardDeleteUrl != "") {
      this.apiDeleteUrl = `${this.$service[this.service.key]}${
        this.model.apiUrls.apiHardDeleteUrl
      }/${this.modelId}/delete/hard`;
    } else {
      this.apiDeleteUrl = `${
        this.$service[this.service.key]
      }/v1/en/console/tabulator/model/${this.model.key}/${
        this.modelId
      }/delete/hard`;
    }

    this.api.setMethod(`POST`);
    this.api.setUrl(this.apiDeleteUrl);
    this.api.setCallbackCompleted(() => {
      this.$router.push({
        name: "PageServiceModelBreadTabulatorBrowse",
        params: {
          serviceKey: this.model.serviceKey,
          modelKey: this.model.key,
        },
        query: { tab: "trash", viewId: "all", tabIndex: 0 },
      });
      this.$store.dispatch("showMessage", {
        message: "Deleted forever successfully.",
        messageType: "success",
        timeout: 2000,
      });
    });
  },
};
</script>
